import { render, staticRenderFns } from "./SayWeeeAuthorize.vue?vue&type=template&id=395ecf0b&scoped=true&"
import script from "./SayWeeeAuthorize.vue?vue&type=script&lang=js&"
export * from "./SayWeeeAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./SayWeeeAuthorize.vue?vue&type=style&index=0&id=395ecf0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ecf0b",
  null
  
)

export default component.exports